import React from "react";
import styled from "styled-components";

const PanelContainer = styled.div<{ $fullHeight?: boolean; bgColor?: string }>`
    display: block;
    background: ${({ bgColor }) => (bgColor ? bgColor : "#fff")};
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 7px 15px 15px 15px;
    margin: 8px 0 8px 0;
    height: ${({ $fullHeight }) => ($fullHeight ? "calc(100% - 16px)" : "auto")};
`;

type PanelProps = {
    fullHeight?: boolean;
    [key: string]: any;
};

const Panel: React.FC<PanelProps> = ({ fullHeight = false, children, ...props }) => {
    return (
        <PanelContainer className="Panel" $fullHeight={fullHeight} {...props}>
            {children}
        </PanelContainer>
    );
};

export default Panel;
